import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './MarketPricingDetails.scss';

class MarketPricingDetails extends Component {
  static propTypes = {
    jobsPricedPercentage: PropTypes.any,
    priceJobClick: PropTypes.func,
    adHocPricingClick: PropTypes.func,
    pricingYear: PropTypes.number,
    launchDarklyFeatureFlags: PropTypes.object,
    permissions: PropTypes.object
  };

  render() {
    const { launchDarklyFeatureFlags, permissions } = this.props;
    let jobsPricedPct = this.props.jobsPricedPercentage >= 0 ? this.props.jobsPricedPercentage : '-';
    jobsPricedPct = jobsPricedPct > 0 && jobsPricedPct < 1 ? '< 1' : jobsPricedPct;
    return (
      <div className="marketpricing__details">
        <div className="marketpricing__details-title">Jobs Priced</div>
        <div className="marketpricing__details-priced">{jobsPricedPct}%</div>
        <div className="marketpricing__details--survey-year">Current Pricing Year: {this.props.pricingYear}</div>
        <div onClick={this.props.priceJobClick} className="marketpricing__details-pricelink">
          Market Price a Job <span className="link__carat">&gt;</span>
        </div>
        {!permissions.reportViewUser && !permissions.restrictedUser && (
          <div onClick={this.props.adHocPricingClick} className="marketpricing__details-ad-hoc-price-link">
            Ad hoc Pricing <span className="link__carat">&gt;</span>
          </div>
        )}
      </div>
    );
  }
}
export default MarketPricingDetails;
